"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setEditCar = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    car: null,
};
var editCarSlice = (0, toolkit_1.createSlice)({
    name: 'editCar',
    initialState: initialState,
    reducers: {
        setEditCar: function (state, action) {
            state.car = action.payload;
        },
    },
});
exports.setEditCar = editCarSlice.actions.setEditCar;
exports.default = editCarSlice.reducer;
